import { useLocation } from 'react-router-dom';

export type FlowType = 'Kit Keeper' | 'Keepr';

export const useFlow = (): FlowType => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const flowParam = searchParams.get('flow');

  if (flowParam === 'keepr') {
    localStorage.setItem('flow', 'Keepr');
    return 'Keepr';
  } else if (flowParam === 'kitkeeper') {
    localStorage.setItem('flow', 'Kit Keeper');
    return 'Kit Keeper';
  }

  const storedFlow = localStorage.getItem('flow');
  return storedFlow === 'Keepr' ? 'Keepr' : 'Kit Keeper';
};
